import { createContext, useContext, useState } from "react";

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [favourites, setFavourites] = useState([]);
  const [cart, setCart] = useState([]);

  const toggleFav = (id) => {
    setFavourites((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

const addToCart = (item) => {
  setCart((prev) => {
    const exist = prev.find(p => p.id === item.id);

    if (exist) {
      return prev.map(p =>
        p.id === item.id ? { ...p, qty: p.qty + 1 } : p
      );
    }

    return [...prev, { ...item, qty: 1 }];   // 👈 FIX: Add qty:1
  });
};

const updateQty = (id, qty) => {
  setCart((prev) =>
    prev.map((item) =>
      item.id === id ? { ...item, qty: Number(qty) || 1 } : item
    )
  );
};


const removeFromCart = (id) => {
  setCart(prev => prev.filter(item => item.id !== id));
};

  return (
    <CartContext.Provider
      value={{
        favourites,
        cart,
        toggleFav,
        addToCart,
        removeFromCart,
        updateQty
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
